import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useIdleTimer} from "react-idle-timer";

import {FormStepper} from "./Elements/FormStepper";
import {InfoBubble} from "./Elements/InfoBubble";
import {UserActive} from "../../Components";
import {SESSIONS_STORAGE_ITEMS, BUBBLE_VISIBLE_IN} from "@config";
import {KYCActions, StepperFormActions, selectCurrentStep, selectStepperFormDraft} from "@redux";
import {ContentLoader} from "@components";

import "./StepsLayout.less";

export const StepsLayout = React.memo(({children}) => {
    const dispatch = useDispatch();
    const currentStep = useSelector(selectCurrentStep);
    const formDraft = useSelector(selectStepperFormDraft);
    
    const [isLoading, setIsLoading] = useState(true);
    const [isInactiveModalOpen, setIsInactiveModalOpen] = useState(false);
    
    const mountedOnce = useRef(false);
    const inactiveTimeout = useRef();
    
    useEffect(() => {
        const userSession = JSON.parse(sessionStorage.getItem(SESSIONS_STORAGE_ITEMS.USER));
        // 0.1 to get 10% of token value, if no token default is 5 mins
        const defaultTimeOut = 1000 * 60 * 5;
        const timeOutTimeInMs = userSession?.timeValid * 0.1 * 1000 || defaultTimeOut;
        inactiveTimeout.current = timeOutTimeInMs;
    }, []);
    
    useEffect(() => {
        if (mountedOnce.current || formDraft.personData) {
            setIsLoading(false);
            return;
        }
        (async () => {
            try {
                await dispatch(KYCActions.startKYC());
                await dispatch(StepperFormActions.getFormDraft());
            } catch {
            } finally {
                setIsLoading(false);
            }
            mountedOnce.current = true;
        })();
    }, []);
    
    const handleOnIdle = () => {
        if (isInactiveModalOpen) return;
        setIsInactiveModalOpen(true);
    };
    
    useIdleTimer({
        timeout: inactiveTimeout.current && inactiveTimeout.current,
        onIdle: handleOnIdle,
        debounce: 10000
    });
    
    return (
        <>
            <div className="main_inner py-3 py-md-5">
                {isLoading && <ContentLoader className="form-loader"/>}
                {!isLoading && (
                    <div className="row flex-nowrap">
                        <div className="col">
                            <FormStepper/>
                        </div>
                        <div className="col-auto">
                            <div
                                className={`stepper-form-container ${
                                    !BUBBLE_VISIBLE_IN.includes(currentStep) ? "w-100" : ""
                                }`}
                            >
                                {children}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {isInactiveModalOpen && (
                <UserActive open={isInactiveModalOpen} onClose={() => setIsInactiveModalOpen(false)}/>
            )}
        </>
    );
});
